import { render, staticRenderFns } from "./SaveStatusIndicator.vue?vue&type=template&id=64b61a50&scoped=true"
import script from "./SaveStatusIndicator.vue?vue&type=script&lang=js"
export * from "./SaveStatusIndicator.vue?vue&type=script&lang=js"
import style0 from "./SaveStatusIndicator.vue?vue&type=style&index=0&id=64b61a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b61a50",
  null
  
)

export default component.exports